export default "__VITE_ASSET__C$zsVYaT__"